import * as React from "react";
import {timer} from 'rxjs';
import {takeWhile, concatMap, take, finalize} from 'rxjs/operators';
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {
    ADD_NEW_CARD,
    AnnualPolicyInfo,
    AnnualPolicyPremiumTypeEnum,
    FalconNavigatorHeader,
    ICacheManager,
    ICustomerPortalService,
    InstalmentsInfo,
    INTERACTION_PROCESS_CLAIM_IMPACT,
    INTERACTION_PROCESS_MTA_ADD_PAY_OFF_BALANCE,
    INTERACTION_PROCESS_MTA_CHANGE_DIRECT_DEBIT,
    INTERACTION_PROCESS_MTA_CHANGE_PAYMENT_DAY, Mandate,
    NEW_OUTSTANDING_PAYMENT,
    Party,
    PaymentCard,
    Policy,
    POLICY_STATUS_RENEWAL,
    PolicyProperty,
    PolicyPropertyEnum,
    PROCESS_PAY_OFF_BALANCE,
    productHelper,
    ProductsEnum, Renewal,
    SETUP_DIRECT_DEBIT, SETUP_DIRECT_DEBIT_REFUND,
    Subscription,
    Types,
    WOLF_MISSED_PAYMENT,
} from "@falcon/services";
import {PluginTemplates} from "../../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../../components/navigation/FalconHeader";
import {PaymentHistoryTable, PaymentHistoryTablePlain} from "../PaymentHistoryTable";
import {PaymentDaySection} from "../PaymentDaySection";
import {StorageSuccessModal} from "../../../../../../components/modals/StorageSuccessModal";
import {AutomaticRenewalCheckboxSection} from "./AutomaticRenewalCheckboxSection";
import {PaymentScheduleSection} from "./PaymentScheduleSection";
import {AccountBalanceSection} from "./AccountBalanceSection";
import {
    calculateInstallmentPayment,
    findMainAnnualPaymentCardByMainCardId,
    findPreviousPolicyVersionByAgreementVersion,
    getAmountToDisplay,
    getNextInstalmentDate,
    getProductByPolicyNumber,
    renderCardTypeName
} from "../../../../../../CommonFunctions";
import * as moment from "moment";
import {CardExpiryBanner} from "../../../../../../components/banners/CardExpiryBanner";
import {
    EditCarMtaSuccessModalWordingGenerator
} from "../../../../annual/motor/yourCarsPage/modal/EditCarMtaSuccessModalWordingGenerator";
import {OverdueInstalmentBanner} from "../../../../../../components/banners/OverdueInstalmentBanner";
import {NextPaymentBanner} from "../../../../../../components/banners/NextPaymentBanner";
import {AnnualPaymentCardsSection} from "./AnnualPaymentCardsSection";
import {DirectDebitSection} from "./DirectDebitSection";
import {InactiveDirectDebitBanner} from "../../../../../../components/banners/InactiveDirectDebitBanner";
import {OutstandingPaymentBanner} from "../../../../../../components/banners/OutstandingPaymentBanner";
import {DirectDebitRenewalPaymentPlanOutput} from "../DirectDebitRenewalPaymentPlanOutput";
import { RenewalPaymentDayChangeModal } from "../../../../../../components/modals/RenewalPaymentDayChangeModal";
import {AllianzOnlineBadge} from "../../../../../../components/AllianzOnlineBadge";

interface IMonthlyPaymentsDetailsPageParams {
    policyNumber: string;
    [key: string]: string | undefined;
}

interface IState {
    policies?: Policy[],
    subscription?: Subscription,
    party?: Party,
    policy?: Policy,
    policiesLoaded: boolean,
    subscriptionLoaded: boolean,
    partyLoaded: boolean,
    instalmentsInfo?: InstalmentsInfo,
    missedPaymentInfo?: InstalmentsInfo,
    showCardExpiryBanner: boolean,
    paymentDay: string,
    renewedPolicy: boolean,
    policiesProcessed: boolean,
    cardExpired?: boolean,
    mainCardId?: string,
    allPoliciesAreCancelled: boolean,
    isMobileScreenSize: boolean,
    canChangePaymentDate: boolean,
    paymentType: string,
    reuseCard: boolean,
    renewalProposal?: any,
    haveMandates: boolean,
    mandate?: any,
    refundMandate?: any,
    previousMonthlyPremium?: number;
    showRenewalChangePaymentDayPopup: boolean;
    paymentHistoryTableKey: number;
}

@authorize
export class MonthlyPaymentsDetailsPagePlain extends React.Component<IWithRouterProps<IMonthlyPaymentsDetailsPageParams>, IState> {

    private static readonly PRIOR_NEXT_INSTALMENT_DATE = 'priorNextInstalmentDate';
    private static readonly PRIOR_NEXT_INSTALMENT_DATE_FORMAT = 'DD-MM-YYYY';

    private readonly pluginTemplates: PluginTemplates = new PluginTemplates();
    private title: string;
    private modalContent: React.ReactNode;
    private anythingElseTitle: any;
    private explanationAnythingElseWording: any;
    private referrerJourney: string | null;
    private showSuccessPopup: string | null;
    private installmentSum: number = 0;
    private readonly product: ProductsEnum;
    private readonly policyNumber: string;

    @lazyInject(Types.CustomerPortalService)
    private readonly customerPortalService: ICustomerPortalService;

    @lazyInject(Types.CacheManager)
    private readonly cacheManager: ICacheManager;

    constructor(props: IWithRouterProps<IMonthlyPaymentsDetailsPageParams>) {
        super(props);

        this.state = {
            policiesLoaded: false,
            subscriptionLoaded: false,
            partyLoaded: false,
            showCardExpiryBanner: false,
            renewedPolicy: false,
            policiesProcessed: false,
            paymentDay: "",
            allPoliciesAreCancelled: true,
            isMobileScreenSize: window.innerWidth < 768,
            canChangePaymentDate: true,
            paymentType: "",
            reuseCard: false,
            haveMandates: false,
            showRenewalChangePaymentDayPopup: window.sessionStorage.getItem("showRenewalChangePaymentDayPopup") === "true",
            paymentHistoryTableKey: 0
        };

        this.pluginTemplates.setPageTitle("Payment details");

        this.policyNumber = this.props.params.policyNumber;
        this.product = getProductByPolicyNumber(this.policyNumber);
    }

    public async componentDidMount() {
        this.cacheManager.clearCache("getPolicies");
        this.cacheManager.clearCache(`getPolicyPropertyByPropertyKey${this.policyNumber},modifiedPaymentDay`);
        this.cacheManager.clearCache("getProfile");

        this.showSuccessPopup = window.sessionStorage.getItem("showPopup");
        if (this.product === ProductsEnum.HOME && !this.showSuccessPopup) {
            window.sessionStorage.removeItem("paymentAmount");
            window.sessionStorage.removeItem("cardNumberObfuscated");
        }
        this.referrerJourney = window.sessionStorage.getItem("referrerJourney");
        this.loadPolicyData();
    }

    private loadPolicyData() {
        this.customerPortalService.getPolicies(this.product, undefined, true)
            .subscribe((policies: Policy[]) => {
                const sortedPolicies: Policy[] = policies.filter((policy: Policy) => policy.products.includes(this.product))
                    .sort((a, b) => moment(b.endDate).diff(a.endDate));

                const allPoliciesAreCancelled = !productHelper.atLeastOneActivePolicy(sortedPolicies);
                this.setState({allPoliciesAreCancelled});

                const filteredPolicies: Policy[] = sortedPolicies
                    .filter((policy: Policy) => policy.products.includes(this.product) && policy.policyNumber === this.policyNumber)
                    .sort((a, b) => moment(b.endDate).diff(a.endDate));

                if (filteredPolicies && filteredPolicies.length > 0) {
                    const policy = filteredPolicies[0];

                    this.customerPortalService.getPolicyPropertyByPropertyKey(policy.policyNumber, "modifiedPaymentDay").subscribe(
                        (property: PolicyProperty) => {
                            if (property !== null) {
                                this.setState({paymentDay: property.value});
                            } else {
                                this.setState({paymentDay: policy.interaction.paymentDay.day});
                            }
                        }
                    );

                    const annualPolicyInfo: AnnualPolicyInfo | undefined = policy.annualPolicyInfo || undefined;
                    const refundMandate: Mandate = policy.annualPolicyInfo?.refundMandate;

                    let mandates = null;
                    if (annualPolicyInfo?.mandates) {
                        mandates = annualPolicyInfo.mandates.filter(
                            (entry: any) => entry.status === "NEW"
                                || entry.status === "REQUESTED"
                                || entry.status === "VALID");
                        this.setState({
                            haveMandates: mandates.length > 0
                        })
                        if (this.state.haveMandates) {
                            mandates.sort((firstMandate: any, secondMandate: any) => secondMandate.id - firstMandate.id);
                            this.setState({
                                mandate: mandates[0]
                            })
                        }
                    }

                    this.setState({
                        policy,
                        refundMandate
                    });

                    this.setInstalmentsInfoAndPaymentHistoryTableKey(policy);

                    if (policy?.interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.ANNUAL &&
                        policy?.interaction?.renewalDetails?.policyAgeYears > 0) {
                        this.customerPortalService.getMissedPaymentInfo(policy.interaction.agreementVersionId).subscribe(
                            (missedPaymentInfo: InstalmentsInfo) => {
                                this.setState({missedPaymentInfo});
                            });
                    }

                    // is policy is renewed
                    const renewedPolicy: boolean = sortedPolicies[0].policyHistoryList.filter(ph => ph.status === POLICY_STATUS_RENEWAL).length > 0;

                    this.setState({
                        renewedPolicy,
                        policies: sortedPolicies,
                        policiesProcessed: true
                    });
                } else {
                    this.setState({
                        policiesProcessed: true
                    });
                }

                this.setState({
                    policiesLoaded: true
                });
            });

        this.customerPortalService.getSubscription().subscribe((subscription: Subscription) => {
            this.setState({
                subscription,
                subscriptionLoaded: true
            });
        });

        this.customerPortalService.getPolicyPropertiesByPropertyKeys(this.policyNumber, [PolicyPropertyEnum.ANNUAL_MONTHLY_OPTION_CARD_EXPIRED, PolicyPropertyEnum.MAIN_ANNUAL_PAYMENT_CARD, PolicyPropertyEnum.REUSE_MAIN_CARD]).subscribe(
            (properties: PolicyProperty[]) => {
                properties.forEach(property => {
                    if (property.key === PolicyPropertyEnum.ANNUAL_MONTHLY_OPTION_CARD_EXPIRED) {
                        this.setState({cardExpired: property.value === 'true'});
                    } else if (property.key === PolicyPropertyEnum.MAIN_ANNUAL_PAYMENT_CARD) {
                        this.setState({mainCardId: property.value})
                    } else if (property.key === PolicyPropertyEnum.REUSE_MAIN_CARD) {
                        this.setState({reuseCard: property.value === 'true'})
                    }
                })
            }
        );

        this.customerPortalService.getPolicyPaymentTypeByPolicyNumber(this.policyNumber).subscribe((paymentType: any) => {
            this.setState({
                paymentType
            });
        });

        this.customerPortalService.getProfile().subscribe((output: Party) => {
            this.setState({
                party: output,
                partyLoaded: true
            })
        });

        this.customerPortalService.isApplicableForPaymentDayChange(this.props.params.policyNumber).subscribe((output: boolean) => {
            this.setState({
                canChangePaymentDate: output
            })
        })

        this.customerPortalService.getRenewalProposal(this.props.params.policyNumber).subscribe((renewalProposal: Renewal) => {
            if (renewalProposal?.factors.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY) {
                this.setState({
                    renewalProposal
                })
            }
        })

        if (this.showSuccessPopup) {
            if (this.referrerJourney === INTERACTION_PROCESS_CLAIM_IMPACT) {
                this.customerPortalService.getPolicyHistory().subscribe(
                    (allPolicies: Policy[]) => {
                        const previousPolicyVersion = findPreviousPolicyVersionByAgreementVersion(allPolicies, this.policyNumber);

                        if (previousPolicyVersion) {
                            const previousInstalments = previousPolicyVersion.interaction.paymentDetails.instalmentPlan.instalments[0];
                            const previousMonthlyPremium = previousInstalments ? previousInstalments.principal + previousInstalments.interest : 0;
                            this.setState({previousMonthlyPremium});
                        }
                    }
                );
            }
        }
    }

    private setInstalmentsInfoAndPaymentHistoryTableKey(policy: Policy) {
        const agreementVersionIds: number[] = policy.policyHistoryList.map(policyHistory => policyHistory.id);
        const priorNextInstalmentDate = window.sessionStorage.getItem(MonthlyPaymentsDetailsPagePlain.PRIOR_NEXT_INSTALMENT_DATE);
        const isAfterMissedPaymentPaid = this.showSuccessPopup && this.referrerJourney === WOLF_MISSED_PAYMENT;
        // Retry should only occur if the missed payment has been paid but the instalments are not yet up to date.
        const maxCalls = isAfterMissedPaymentPaid ? 4 : 1;
        timer(0, 500)
            .pipe(
                take(maxCalls),
                concatMap(() => this.customerPortalService.getCombinedInstalmentsInfo(agreementVersionIds)),
                takeWhile(
                    (instalmentsInfo: any) => this.shouldRetry(maxCalls, instalmentsInfo, priorNextInstalmentDate),
                    true
                ),
                finalize(() => {
                    if (isAfterMissedPaymentPaid) {
                        this.setState(prevState => ({
                            paymentHistoryTableKey: prevState.paymentHistoryTableKey + 1
                        }));
                    }
                })
            )
            .subscribe((instalmentsInfo: any) => {
                this.setState({instalmentsInfo});
                const nextInstalmentDate = getNextInstalmentDate(instalmentsInfo);
                if (nextInstalmentDate.isValid()) {
                    const nextInstalmentDateAsString = nextInstalmentDate.format(MonthlyPaymentsDetailsPagePlain.PRIOR_NEXT_INSTALMENT_DATE_FORMAT);
                    window.sessionStorage.setItem(MonthlyPaymentsDetailsPagePlain.PRIOR_NEXT_INSTALMENT_DATE, nextInstalmentDateAsString);
                } else {
                    window.sessionStorage.removeItem(MonthlyPaymentsDetailsPagePlain.PRIOR_NEXT_INSTALMENT_DATE);
                }
            });
    }

    private shouldRetry(maxCalls: number, instalmentsInfo: any, previousNextInstalmentDate: string | null) {
        if (maxCalls === 1 || previousNextInstalmentDate === null) {
            return false;
        }

        const nextInstalmentDate = getNextInstalmentDate(instalmentsInfo);
        if (!nextInstalmentDate.isValid()) {
            return false;
        }

        const nextInstalmentDateAsString = nextInstalmentDate.format(MonthlyPaymentsDetailsPagePlain.PRIOR_NEXT_INSTALMENT_DATE_FORMAT);
        return previousNextInstalmentDate === nextInstalmentDateAsString;
    }

    public render() {
        const loading: boolean = !(this.state.policiesLoaded && this.state.subscriptionLoaded && this.state.partyLoaded && this.state.policiesProcessed);
        const annualPolicyInfo: AnnualPolicyInfo | undefined = this.state.policy ? this.state.policy.annualPolicyInfo : undefined;
        const instalmentsInfo: InstalmentsInfo | undefined = this.state.missedPaymentInfo ?? this.state.instalmentsInfo;
        const canChangePaymentDate: boolean | undefined = this.state.canChangePaymentDate;
        const isDirectDebitPaymentType: boolean = this.state.paymentType === "directDebit";

        this.setPopups();

        const lastPolicyInteraction = this.getLastPolicyInteraction();
        const showCardExpiryBanner: boolean = this.state.cardExpired !== undefined;

        let activePolicy: any = null;
        let product: any = null;
        let payOffInstallmentPresent: boolean = false;

        if (instalmentsInfo?.instalments !== undefined) {
            payOffInstallmentPresent = instalmentsInfo.instalments.filter((instalment) => instalment.description.includes("PayOffBalance")).length > 0;
        }

        if (this.state.policiesLoaded && this.state.policies) {
            if (this.state.policies?.some(policy => productHelper.isWolfMotor(policy.interaction))) {
                activePolicy = productHelper.getActiveAnnualMotorPolicy(this.state.policies, this.policyNumber);
                product = "annualMotor";
            } else {
                activePolicy = productHelper.getActiveAnnualHomePolicy(this.state.policies, this.policyNumber)
                product = "annualHome";
            }
        }

        let haveActiveMandate: boolean = false;
        let mandate = null;
        if (annualPolicyInfo?.mandates && annualPolicyInfo.mandates.length > 0) {
            const mandates = annualPolicyInfo.mandates.sort((firstMandate: any, secondMandate: any) => secondMandate.id - firstMandate.id);
            mandate = mandates[0];
            haveActiveMandate = mandate.status === "REQUESTED" || mandate.status === "NEW" || mandate.status === "VALID";
        }

        this.installmentSum = calculateInstallmentPayment(this.state.instalmentsInfo?.instalments);
        const showOverdueInstalmentBanner: boolean = !!annualPolicyInfo && annualPolicyInfo.hasDebt;
        const isDirectDebit: boolean = this.state.renewalProposal?.paymentDetails.paymentType === "directDebit";

        const hasInstalmentsInfo: boolean = this.state.instalmentsInfo !== undefined;

        const hasCurrentPolicyPendingInstalments: boolean =
            this.hasPendingInstalments(this.state.instalmentsInfo?.instalments);

        const isCurrentPolicyPaidOff: boolean =
            hasInstalmentsInfo && !hasCurrentPolicyPendingInstalments;

        const shouldShowRenewalDirectDebitSchedule: boolean =
            this.state.policiesLoaded
            && isDirectDebit
            && hasInstalmentsInfo
            && !hasCurrentPolicyPendingInstalments;

        const shouldShowCurrentPolicySchedule: boolean = !!(
            this.state.policiesLoaded
            && this.state.policies
            && hasInstalmentsInfo
            && (!isDirectDebit || hasCurrentPolicyPendingInstalments)
        );

        return (

            <div className="dashboard payment-details">

                {this.showSuccessPopup &&
                    <StorageSuccessModal
                        title={this.title}
                        explanationWording={this.modalContent}
                        anythingElseTitle={this.anythingElseTitle}
                        explanationAnythingElseWording={this.explanationAnythingElseWording}
                        onClose={this.modalOnClose}
                    />
                }

                {this.state.showRenewalChangePaymentDayPopup &&
                    <RenewalPaymentDayChangeModal scrollElementId={"paymentScheduleTable"} />
                }

                <FalconHeader/>

                <div className="plugin">
                    <AllianzOnlineBadge/>
                    <FalconNavigatorHeader
                        back={{
                            link: `/dashboard/${product}/${this.state.policy?.policyNumber}`,
                            hidden: !this.state.policy
                        }}
                        title="Payment details"
                    />
                    {this.state.policy && !!this.state.policy.annualPolicyInfo.unpaidChargebackInvoiceAmount && this.referrerJourney !== NEW_OUTSTANDING_PAYMENT &&
                        <OutstandingPaymentBanner
                            amount={this.state.policy.annualPolicyInfo.unpaidChargebackInvoiceAmount}
                            policyNumber={this.state.policy.policyNumber}
                            product={this.state.policy.interaction.product}
                        />
                    }

                    {showOverdueInstalmentBanner && annualPolicyInfo &&

                            <OverdueInstalmentBanner amount={annualPolicyInfo.overdueMonthlyInvoiceAmount}
                                                     unpaidInstallmentIdToAmount={annualPolicyInfo.unpaidInstallmentIdToAmount}
                                                     policyNumber={lastPolicyInteraction.agreementNumber}
                                                     product={this.product}
                                                     ncdImpactedClaim={this.state.policy?.interaction.uistate.policyHasNcdImpactedClaims}
                                                     isDirectDebit={isDirectDebitPaymentType}
                                                        reuseCard={this.state.reuseCard}/>
                        }


                    {(!showOverdueInstalmentBanner || !annualPolicyInfo?.overdueMonthlyInvoiceAmount) && instalmentsInfo && (
                        <NextPaymentBanner showInfoModal={false} paymentDate={getNextInstalmentDate(instalmentsInfo)}
                                           instalmentsInfo={instalmentsInfo} smallScreenMarginRequired={true}/>
                    )}
                    {lastPolicyInteraction && isDirectDebitPaymentType && !haveActiveMandate  && this.state.instalmentsInfo != null && Math.abs(this.state.instalmentsInfo.payOffAmount!) > 0 && (
                        <InactiveDirectDebitBanner policyNumber={this.policyNumber} smallScreenMarginRequired={true}/>
                    )}

                    {this.state.party && showCardExpiryBanner &&
                        <div className="inner-container">
                            <CardExpiryBanner
                                party={this.state.party}
                                mainCardId={this.state.mainCardId!}
                                policyNumber={this.policyNumber}
                                annualMonthlyOptionCardExpired={this.state.cardExpired!}
                            />
                        </div>}

                    <div className="panel bg-white overflow-hidden p-0 mx-3 font-weight-extra-light">
                        <div className="inner-content pb-4 payment-details-table">
                            {this.state.policiesLoaded && this.state.instalmentsInfo?.remainingAmount !== 0 &&
                                (<>
                                    <PaymentDaySection allPoliciesAreCancelled={this.state.allPoliciesAreCancelled}
                                                       renewalPaymentFailed={this.state.subscription?.renewalPaymentFailed}
                                                       interaction={lastPolicyInteraction}
                                                       paymentType="annual-product-monthly-payments"
                                                       paymentDay={this.state.paymentDay}
                                                       canChangePaymentDate={canChangePaymentDate}/>
                                    <div className="dashed-10"/>
                                </>)
                            }
                            {this.state.policiesLoaded && isDirectDebitPaymentType && !payOffInstallmentPresent &&
                                (<>
                                    <DirectDebitSection haveActiveMandate={haveActiveMandate}
                                                        policyNumber={this.props.params.policyNumber}
                                                        interaction={lastPolicyInteraction} mandate={mandate}/>
                                    <div className="dashed-10"/>
                                </>)
                            }
                            {this.state.policiesLoaded && !!this.state.refundMandate &&
                                <>
                                    <DirectDebitSection haveActiveMandate={true}
                                                        policyNumber={this.props.params.policyNumber}
                                                        interaction={this.state.policy?.interaction}
                                                        mandate={this.state.refundMandate}
                                                        isRefundMandate={true}
                                    />
                                    <div className="dashed-10"/>
                                </>
                            }

                            <AnnualPaymentCardsSection
                                policyNumber={this.policyNumber}
                                payment="monthly"
                                handleReuseCardChange={this.handleReuseCardChange}/>

                            {this.state.policiesLoaded && isDirectDebit &&
                                <>
                                    <div className="dashed-10"/>
                                    <PaymentDaySection
                                        allPoliciesAreCancelled={this.state.allPoliciesAreCancelled}
                                        interaction={this.state.renewalProposal}
                                        paymentType="annual-product-monthly-payments"
                                        paymentDay={this.getPaymentDay()}
                                        canChangePaymentDate={true}
                                        renewalPaymentFailed={false}
                                        annualToMonthly={true}/>
                                </>
                            }

                            {this.state.policiesLoaded && mandate && isDirectDebit &&
                                <>
                                    <div className="dashed-10"/>
                                    <DirectDebitSection haveActiveMandate={this.state.haveMandates}
                                                        policyNumber={this.props.params.policyNumber}
                                                        interaction={this.state.renewalProposal}
                                                        mandate={mandate}
                                                        annualToMonthly={true}/>
                                </>
                            }

                            {shouldShowRenewalDirectDebitSchedule &&
                                (<>
                                    <div className="dashed-10"/>
                                    <div id="paymentScheduleTable">
                                        <DirectDebitRenewalPaymentPlanOutput
                                            interaction={this.state.renewalProposal}/>
                                    </div>
                                </>)
                            }

                            {shouldShowCurrentPolicySchedule &&
                                (<>
                                    <div className="dashed-10"/>
                                    <PaymentScheduleSection
                                        paidAmount={this.state.instalmentsInfo?.paidAmount}
                                        installmentSum={this.installmentSum}
                                        instalments={this.state.instalmentsInfo?.instalments || []}
                                        totalAmount={this.state.instalmentsInfo?.totalAmount}
                                        interaction={this.state.policies![0].interaction}
                                        isPaidOff={isCurrentPolicyPaidOff}/>
                                </>)
                            }
                            {lastPolicyInteraction != null
                                && this.state.instalmentsInfo != null
                                && this.state.instalmentsInfo.remainingPremium! > 0
                                && this.state.instalmentsInfo.payOffAmountWithRemainingInterest! > 0
                                && (
                                    <>
                                        <div className="dashed-10"/>
                                        <AccountBalanceSection
                                            interaction={lastPolicyInteraction}
                                            policyNumber={this.props.params.policyNumber}
                                            reuseCard={this.state.reuseCard}
                                            payOffAmountWithRemainingInterest={this.state.instalmentsInfo.payOffAmountWithRemainingInterest}
                                            remainingInterest={this.state.instalmentsInfo.remainingInterest}/>
                                    </>
                                )
                            }

                            {!this.state.renewedPolicy
                                &&
                                <>
                                    <div className="dashed-10"/>
                                    <div className="blue-line"/>
                                    <PaymentHistoryTable
                                        key={this.state.paymentHistoryTableKey}
                                        subscription={this.state.subscription}
                                        showProduct={this.product}
                                        paymentPeriod={PaymentHistoryTablePlain.PaymentPeriod.all}
                                        paymentType="monthly"/>
                                </>}


                            {this.state.renewedPolicy
                                &&
                                <>
                                    <div className="dashed-10"/>
                                    <PaymentHistoryTable
                                        key={this.state.paymentHistoryTableKey}
                                        title="Existing policy payment history"
                                        subscription={this.state.subscription}
                                        showProduct={this.product}
                                        expanded={true}
                                        paymentPeriod={PaymentHistoryTablePlain.PaymentPeriod.current}
                                        paymentType="monthly"/>
                                    <div className="dashed-10"/>
                                    <PaymentHistoryTable
                                        title="Old policies payment history"
                                        subscription={this.state.subscription}
                                        showProduct={this.product}
                                        paymentPeriod={PaymentHistoryTablePlain.PaymentPeriod.past}
                                        paymentType="monthly"/>
                                </>
                            }

                        </div>
                    </div>

                    {activePolicy &&
                        <AutomaticRenewalCheckboxSection
                            navigate={this.props.navigate}
                            activeAnnualPolicy={activePolicy}
                            product={this.product}
                        />}

                    {this.state.policy && this.pluginTemplates.renderBackLink("Back", false, `/dashboard/${product}/${this.state.policy.policyNumber}`)}
                </div>

                <FalconFooter/>
                <Overlay show={loading}/>
            </div>
        );
    }
    private readonly getInstalmentAmount = (instalment: any): number => {
        if (typeof instalment.amount === "number") {
            return instalment.amount;
        }

        if (typeof instalment.principal === "number" || typeof instalment.interest === "number") {
            return (instalment.principal ?? 0) + (instalment.interest ?? 0);
        }

        return 0;
    }

    private readonly hasPendingInstalments = (instalments?: any[]): boolean => {
        return (instalments ?? []).some((instalment: any) => {
            const isAdminFee = instalment.description?.includes("Admin Fee");
            const amount = this.getInstalmentAmount(instalment);

            return !isAdminFee && amount > 0 && instalment.status !== "PAID";
        });
    }

    private getLastPolicyInteraction(): any {
        return this.state.policy ? this.state.policy.interaction : null;
    }

    private getPaymentDay(): any {
        return this.state.haveMandates ? (this.state.renewalProposal?.paymentDetails?.directDebitDetails?.paymentDay ?? this.state.renewalProposal.paymentDay.day) : this.state.renewalProposal.paymentDay.day
    }

    private modalOnClose(): void {
        window.sessionStorage.removeItem("paymentAmount");
        window.sessionStorage.removeItem("cardNumberObfuscated");
    }

    private readonly setPaymentDayChangePopup = (): void => {
        if (this.state.policiesLoaded && this.state.policies) {
            this.title = "All done!";
            this.modalContent =
                <div>
                    <p>
                        You have a new payment day,
                        every {PluginTemplates.convertWolfPaymentDate(this.state.paymentDay)} of the month.
                    </p>
                </div>

            this.anythingElseTitle = EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle();
            this.explanationAnythingElseWording = EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody();
        }
    }

    private readonly setManualPaymentSuccessPopup = (): void => {
        let cardNumberObfuscated = window.sessionStorage.getItem("cardNumberObfuscated");
        if (!cardNumberObfuscated) {
            cardNumberObfuscated = findMainAnnualPaymentCardByMainCardId(this.state.party!, this.state.mainCardId!)?.cardNumberObfuscated!;
        }
        this.title = "Payment was successful";
        this.modalContent =
            <p>
                <span className="font-weight-bold"
                      id={"paymentAmount"}>{window.sessionStorage.getItem("paymentAmount")}&nbsp;</span>
                have been debited from your card ending <b> {cardNumberObfuscated?.split('******')[1]} </b> to pay your overdue instalment
            </p>;
        this.anythingElseTitle = EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle();
        this.explanationAnythingElseWording = EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody();
    }

    private setNewCardPopup(): void {
        const paymentCard: PaymentCard | null = findMainAnnualPaymentCardByMainCardId(this.state.party!, this.state.mainCardId!);
        if (paymentCard) {
            this.title = "All done!";
            this.modalContent =
                <p className="font-weight-bold">
                    You have a new payment method, {renderCardTypeName(paymentCard)} card ending
                    in {paymentCard.cardNumberObfuscated.split('******')[1]}
                </p>;
            this.anythingElseTitle = "";
            this.explanationAnythingElseWording = "";
        }
    }

    private setDirectDebitSetupPopup(): void {
        this.title = "All done!";
        this.modalContent =
            <p>
                Your new Direct Debit details have been updated along with your Direct Debit reference. You'll be able
                to see a new payment plan in your 'Documents' tile shortly.
            </p>;
        this.anythingElseTitle = "";
        this.explanationAnythingElseWording = "";
    }

    private setDirectDebitRefundSetupPopup(): void {
        this.title = "All done!";
        this.modalContent =
            <p>
                Your new Direct Debit is ready.
                We need this so we can refund to your bank account (we won’t use it to take any payments). When your refund arrives, you can cancel this Direct Debit with your bank.
            </p>;
        this.anythingElseTitle = "";
        this.explanationAnythingElseWording = "";
    }

    private setPayOffBalancePopup(): void {
        const paymentAmount: string | null = window.sessionStorage.getItem("paymentAmount");
        let activePolicy: any = null;
        if (this.state.policiesLoaded && this.state.policies) {
            if (this.state.policies?.some(policy => productHelper.isWolfMotor(policy.interaction))) {
                activePolicy = productHelper.getActiveOrCancelledAnnualMotorPolicy(this.state.policies, this.policyNumber);
            } else {
                activePolicy = productHelper.getActiveOrCancelledHomePolicy(this.state.policies, this.policyNumber)
            }

            this.title = "Payment was successful";
            this.modalContent = (
                <>
                    <p className="mb-0">
                        {paymentAmount ?? getAmountToDisplay(activePolicy.interaction.factors.payOffPremium)} has been
                        taken out
                        from your account for paying off
                        your {productHelper.isWolfMotor(activePolicy.interaction) ? "car" : "home"} insurance.
                    </p>
                    <p>
                        Please allow a couple of minutes for the payment to be updated in your account.
                    </p>
                </>
            )
        }
    }

    private setChargeBackPayoff(): void {
        window.sessionStorage.setItem("outstandingPaid", "true");
        const paymentAmount: string | null = window.sessionStorage.getItem("paymentAmount");
        const paymentCard: PaymentCard | null = findMainAnnualPaymentCardByMainCardId(this.state.party!, this.state.mainCardId!);
        if (this.state.policiesLoaded) {
            this.title = "Payment was successful";
            this.modalContent = (
                <p className="mb-0">
                    <span className="font-weight-bold">{paymentAmount}</span> has been debited from your card
                    ending <span className="font-weight-bold">{paymentCard && Boolean(paymentCard) ? paymentCard.cardNumberObfuscated.split('******')[1] : '****'}</span> to pay your <span className="font-weight-bold">outstanding balance</span>.
                </p>
            )
        }
    }

    private readonly setClaimImpactSpreadPopup = (): void => {
        if (this.state.previousMonthlyPremium) {
            const monthlyPaymentSpreadAmount = this.state.policy?.interaction.factors.additionalPremium;
            const monthlyPremium = this.state.policy?.interaction.factors.monthlyPremium;

            this.title = "All done!";
            this.modalContent =
                <div className="font-weight-extra-light">
                    <p>You currently pay <span className="font-weight-semi-bold">
                    {getAmountToDisplay(this.state.previousMonthlyPremium)}
                </span> a month.
                    </p>
                    <p>The additional cost of <span className="font-weight-semi-bold">
                        {getAmountToDisplay(monthlyPaymentSpreadAmount)}
                    </span> has increased your remaining monthly payments to <span className="font-weight-semi-bold">
                {getAmountToDisplay(monthlyPremium)} / month.</span>
                    </p>
                </div>

            this.anythingElseTitle = EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalTitle();
            this.explanationAnythingElseWording = EditCarMtaSuccessModalWordingGenerator.generateAnythingElseChangedModalBody();
        }
    }

    private setPopups(): void {
        this.referrerJourney = window.sessionStorage.getItem("referrerJourney");

        if (this.state.partyLoaded && this.state.policies) {
            if (this.referrerJourney === INTERACTION_PROCESS_MTA_CHANGE_PAYMENT_DAY) {
                this.setPaymentDayChangePopup();
            } else if (this.referrerJourney === WOLF_MISSED_PAYMENT) {
                this.setManualPaymentSuccessPopup();
            } else if (this.referrerJourney === ADD_NEW_CARD) {
                this.setNewCardPopup();
            } else if (this.referrerJourney === SETUP_DIRECT_DEBIT ||
                this.referrerJourney === INTERACTION_PROCESS_MTA_CHANGE_DIRECT_DEBIT) {
                this.setDirectDebitSetupPopup();
            } else if (this.referrerJourney === SETUP_DIRECT_DEBIT_REFUND) {
                this.setDirectDebitRefundSetupPopup();
            } else if (this.referrerJourney === NEW_OUTSTANDING_PAYMENT) {
                this.setChargeBackPayoff();
            } else if (this.referrerJourney === PROCESS_PAY_OFF_BALANCE || this.referrerJourney === INTERACTION_PROCESS_MTA_ADD_PAY_OFF_BALANCE) {
                this.setPayOffBalancePopup();
            } else if (this.referrerJourney ===  INTERACTION_PROCESS_CLAIM_IMPACT) {
                this.setClaimImpactSpreadPopup();
            } else {
                window.sessionStorage.removeItem("showPopup");
                window.sessionStorage.removeItem("referrerJourney");
            }
        }
    }

    private readonly handleReuseCardChange = (reuseValue: boolean) => {
        this.setState({reuseCard: reuseValue})
    }

}

export const MonthlyPaymentsDetailsPage = withRouter<{}, IMonthlyPaymentsDetailsPageParams>(MonthlyPaymentsDetailsPagePlain)
